module.exports = __webpack_public_path__ + "static/wwd-add740d142f37ee93223ef8acef8b70d.jpg";